import { useSharesActions } from "store/SharesSlice";

const useShares = () => {
  const { createShare } = useSharesActions();

  return { createShare };
};

export default useShares;
